import React from 'react';
import { RetentionCenter } from './pages/RetentionCenter';
export function App() {
  return <RetentionCenter data-id="element-0" data-mp="35ck9w61lj0ig" />;
}